import React from 'react'

const DinnerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.33329 12.25L1.16663 11.0833H12.8333L11.6666 12.25H2.33329ZM1.74996 10.5C1.80829 10.325 1.88607 10.1597 1.98329 10.0042C2.08051 9.84861 2.19718 9.70278 2.33329 9.56667V5.25H1.74996V4.375H2.33329V3.9375H1.74996V3.0625H2.33329V2.625H1.74996V1.75H5.83329C6.15413 1.75 6.42878 1.86424 6.65725 2.09271C6.88572 2.32118 6.99996 2.59583 6.99996 2.91667V3.0625H12.25V3.9375H6.99996V4.08333C6.99996 4.40417 6.88572 4.67882 6.65725 4.90729C6.42878 5.13576 6.15413 5.25 5.83329 5.25H4.66663V8.80833C4.80274 8.82778 4.93885 8.85694 5.07496 8.89583C5.21107 8.93472 5.33746 8.99306 5.45413 9.07083C5.7069 8.43889 6.11038 7.93576 6.66454 7.56146C7.21871 7.18715 7.83121 7 8.50204 7C9.37704 7 10.1232 7.29896 10.7406 7.89687C11.3579 8.49479 11.6666 9.22639 11.6666 10.0917V10.5H1.74996ZM4.66663 3.0625H5.83329V2.625H4.66663V3.0625ZM4.66663 4.375H5.83329V3.9375H4.66663V4.375ZM3.20829 3.0625H3.79163V2.625H3.20829V3.0625ZM3.20829 4.375H3.79163V3.9375H3.20829V4.375ZM3.20829 8.95417C3.30551 8.90556 3.40031 8.8691 3.49267 8.84479C3.58503 8.82049 3.68468 8.79861 3.79163 8.77917V5.25H3.20829V8.95417Z'
      fill='currentColor'
    />
  </svg>
)

export default DinnerIcon
